import PropTypes from 'prop-types';
import { useLocales } from '../../locales';

import { PLATFORM_ICONS } from '../../config/icons';

import { GOOGLE, SHORT_ANALYTICS_METRICS_TITLES } from '../../config/constants';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Tooltip } from 'react-bootstrap';
import { useState } from 'react';
import { duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const AnalyticsTable = ({ data, platforms, isVideo, post }) => {
  const { translate: t } = useLocales();

  if (!post)
    return (
      <div
        style={{ height: 195 }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <p className="text-muted w-75 text-center">
          {t("short_analytics_table.analytics_data_is_currently_synchronizing")}
        </p>
        <i className="fa-duotone fa-rotate fa-2x"></i>
      </div>
    );
  return (
    <table className="w-100 table table-striped">
      <thead>
        <tr>
          <th></th>
          {platforms?.map((item) => {
            if (item === GOOGLE) return "";
            return (
              <th className="text-dark-50 text-center" key={item}>
                <span>
                  <i className={`${PLATFORM_ICONS[item]} text-dark-50`}></i>
                </span>
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {SHORT_ANALYTICS_METRICS_TITLES.map((title) => {
          return (
            <Tr title={title} platforms={platforms} key={title} post={post} showAsPercentage={title == "engagement"} />
          );
        })}
      </tbody>
    </table>
  );
};
AnalyticsTable.propTypes = {
  data: PropTypes.object,
  isVideo: PropTypes.bool,
  platforms: PropTypes.array,
  post: PropTypes.object,
};

// -----------------

const Tr = ({ platforms, title, post, showAsPercentage = false }) => {
  const { translate: t } = useLocales();
  const [maxValue, setMaxValue] = useState(0);
  const [maxIndex, setMaxIndex] = useState(0);

  return (
      <tr>
        <td className="ps-5">{t(title)}</td>
        {platforms.map((platform, index) => {
          if (platform === GOOGLE) return "";

          const currentValue = post.overview?.[platform]?.[title];
          if (currentValue > maxValue) {
            setMaxValue(currentValue);
            setMaxIndex(index);
          }

          const displayValue =
              currentValue != null
                  ? showAsPercentage
                      ? `${parseFloat(currentValue.toFixed(2))}%`
                      : Intl.NumberFormat("en-US", {
                        notation: "compact",
                        compactDisplay: "short",
                      }).format(currentValue)
                  : null;

          return (
              <td
                  className={`text-center ${
                      maxIndex === index && currentValue !== 0
                          ? "fw-bolder text-primary"
                          : ""
                  }`}
                  key={platform}
              >
                {displayValue !== null ? displayValue : <MetricNotAvailable />}
              </td>
          );
        })}
      </tr>
  );
};


Tr.propTypes = {
  data: PropTypes.object,
  platforms: PropTypes.array,
  title: PropTypes.string,
  post: PropTypes.object,
  showAsPercentage: PropTypes.bool,
};

function MetricNotAvailable() {
  const { translate: t } = useLocales();
  return (
    <OverlayTrigger
      placement="bottom"
      overlay={
        <Tooltip id="button-tooltip-2">
          {t("metric_not_available_for_platform")}
        </Tooltip>
      }
    >
      {({ ref, ...triggerHandler }) => (
        <span {...triggerHandler} ref={ref} className="p-1">
          -
        </span>
      )}
    </OverlayTrigger>
  );
}

export default MetricNotAvailable;
